export default __webpack_public_path__ + "static/media/collab.0578d11d.png";